<template>
    <v-card v-if="liga" :flat="$vuetify.breakpoint.smAndDown" >
        <meisterschaft-header :liga-name="ligaName" @meisterschaftAction="meisterschaftAction" :sport-jahr="sportJahr"
                              :bewerb="bewerb" :landesverband-id="landesverband.id"/>
    <!-- Switch Damen, Herren, Mixed -->
        <meisterschaft-bewerb-switch :liga="liga" :meisterschaftBewerbe="meisterschaftBewerbe"
                                     @loadSelectedBewerb="loadSelectedBewerb"/>
    <!-- Bewerb-Status -->
        <meisterschaft-bewerb-aktionen v-if="bewerb" :bewerb="bewerb" :landesverband-id="landesverband.id"
                                       @refreshBewerb="loadSelectedBewerb"/>
        <div v-if="isLoading" class="text-center pb-10">
            <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
        </div>
        <div v-else>
            <meisterschaft-bewerb-empty v-if="!bewerb" :landesverband-id="landesverband.id"
                                        @addBewerb="meisterschaftAction" class="pb-1"/>
            <div v-else-if="!bewerbHasTabs">
                <meisterschaft-runde :runde="bewerb?.runden['10']"
                                     :bewerb="bewerb"
                                     :landesverband-id="landesverband.id"
                                     @editTeam="rundenAction"
                                     @editResult="rundenAction"
                                     @refreshBewerb="loadSelectedBewerb"
                                     @editSettings="rundenAction"
                                     @editSpielResult="editSpielResult"
                                     @confirmClearSpiel="confirmClearSpiel"
                />
            </div>
            <meisterschaft-runden v-else :bewerb="bewerb"
                                    :landesverband-id="landesverband.id"
                                     @refreshBewerb="loadSelectedBewerb"
                                     @editSettings="rundenAction"
                                     @editTeam="rundenAction"
                                     @editSpielResult="editSpielResult"
                                     @editResult="rundenAction"
                                     @confirmClearSpiel="confirmClearSpiel"
            />
        </div>
    <!-- Edit components -->
        <meisterschaft-bewerb-edit :currentData="bewerb" :landesverband="landesverband" :header="ligaName"
                                    :liga="liga" :sport-jahr="sportJahr" :spiel-typ="liga?.spielTyp"
                                   @bewerbChanged="setBewerb"/>
        <meisterschaft-team-edit v-if="!isLoading" :current-data="currentTeam" :current-runde="currentRunde" :current-spiel="currentSpiel"
                                 :bewerb="bewerb" :spiel-typ="liga?.spielTyp"/>
        <meisterschaft-runde-tab-result-edit :current-data="currentTeam" :currentRunde="currentRunde" :bewerb="bewerb"/>
        <meisterschaft-runde-ko-settings-edit :current-data="currentRunde" :bewerb="bewerb"/>
        <spiel-ko-result-edit :current-data="currentSpiel" :bewerb="bewerb"/>
        <spiel-ko-clear :spiel="currentSpiel" :runde="currentRunde" :bewerb="bewerb"
                        :confirm-clear-open="confirmClearOpen" @closeClear="closeSpielClearConfirm"/>
    </v-card>
</template>

<script>
import MeisterschaftHeader from "@/views/ergebnisdienst/meisterschaft/meisterschaftHeader.vue";
import MeisterschaftBewerbSwitch from "@/views/ergebnisdienst/meisterschaft/meisterschaftBewerbSwitch.vue";
import MeisterschaftBewerbEmpty from "@/views/ergebnisdienst/meisterschaft/meisterschaftBewerbEmpty.vue";
import FirebaseRead from "@/services/database/firebaseRead";
import MeisterschaftBewerbEdit from "@/views/ergebnisdienst/meisterschaft/meisterschaftBewerbEdit.vue";
import {MEISTERSCHAFT_BEWERBE} from "@/services/data/meisterschaften/bewerb_constants";
import {Bewerb} from "@/services/data/meisterschaften/bewerb";
import MeisterschaftRunde from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRunde.vue";
import MeisterschaftTeamEdit from "@/views/ergebnisdienst/meisterschaft/teams/meisterschaftTeamEdit.vue";
import MeisterschaftRundeTabResultEdit
    from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRundeTabResultEdit.vue";
import MeisterschaftRunden from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRunden.vue";
import MeisterschaftRundeKoSettingsEdit
    from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRundeKoSettingsEdit.vue";
import SpielKoResultEdit from "@/views/ergebnisdienst/meisterschaft/spiele/spielKoResultEdit.vue";
import MeisterschaftBewerbAktionen from "@/views/ergebnisdienst/meisterschaft/meisterschaftBewerbAktionen.vue";
import SpielKoClear from "@/views/ergebnisdienst/meisterschaft/spiele/spielKoClear.vue";

// TODO Go Live Prod:
//  Rules und Functions kopieren,
//  Chris die Rechte für die Vergabe von meisterschaftenOperator geben

/*
    TODO:
    BehindertenStatus
    - es gibt eine Spalte Handicap im Export
    - es gibt eine Spalte Bemerkungen im Export
    Stand nach Prüfung 31.1.2025:
    - es gibt die Felder, allerdings ist Handicap ein String
    => Rückfrage Franz bei Einschulung, welche Werte es da geben kann???
 */

export default {
    name: "meisterschaft",
    components: {
        SpielKoClear,
        MeisterschaftBewerbAktionen, SpielKoResultEdit, MeisterschaftRundeKoSettingsEdit, MeisterschaftRunden, MeisterschaftRundeTabResultEdit,
        MeisterschaftTeamEdit, MeisterschaftRunde, MeisterschaftBewerbEdit, MeisterschaftBewerbEmpty,
        MeisterschaftBewerbSwitch, MeisterschaftHeader},
    props: ['liga', 'sportJahr', 'landesverband'],
    computed: {
        tabRundeAdded(){
            return this.bewerb ? {
                bewerbId: this.bewerb.id,
                tabs: Object.keys(this.bewerb?.settings.tabs).length
            } : {
                bewerbId: null,
                tabs: null
            }
        },
        bewerbHasTabs(){ return this.bewerb && Object.keys(this.bewerb?.settings.tabs).length>1 },
        ligaType(){ return this.$store.state.local.ligaTypes.find(type => type.value === this.liga.type) },
        meisterschaftBewerbe() { return this.meisterschaftBewerbeRaw.filter(bewerbTyp => this.liga.bewerbe.includes(bewerbTyp.value))
                                                                    .sort((a, b) => a.sort > b.sort ? 1 : -1)},
        actionParam(){ return this.$route.query.action },
        ligaLabelLong(){ return this.landesverband?.id==='1' ? this.ligaType.labelLong : this.ligaType.labelLongAlt },
        ligaName() { const bewerbsNameOpt = this.liga.bewerbe.length !== 1 ? '' :
                        ' ' + this.meisterschaftBewerbe.find(bewerb => bewerb.value === this.liga.bewerbe[0]).label
                    return this.landesverband.prefix + this.ligaLabelLong + ' ' + this.liga.name + bewerbsNameOpt },
        ligaIdParam(){ return this.$route.query.itemId },
    },
    data: () => ({
        meisterschaftBewerbeRaw: MEISTERSCHAFT_BEWERBE,
        bewerb: null,
        currentBewerb: null,
        currentRunde: null,
        currentTeam: null,
        currentSpiel: null,
        isLoading: false,
        confirmClearOpen: false,
    }),
    created(){
        if ( this.actionParam ) { window.history.back() }
        if ( this.$route.query.bewerbTyp ) {
            this.loadSelectedBewerb(this.$route.query.bewerbTyp)
            this.replaceSportJahrRoute()
        }
    },
    destroyed() {
        if ( this.$route.query.sportJahr ) {
            let p = JSON.parse(JSON.stringify(this.$route.path));
            let q = JSON.parse(JSON.stringify(this.$route.query));
            delete q.sportJahr
            this.$router.replace({path: p, query: q});
        }
    },
    methods: {
        async loadSelectedBewerb(bewerbTyp){
            this.isLoading = true;
            this.resetCurrentData()
            const documentId = this.liga.id + '_' + this.sportJahr + '_' + bewerbTyp
            console.log ("!!!!!!!!!! LOAD DATA!!!", documentId);
            const bewerb = await FirebaseRead.readSingleDoc('meisterschaftenBewerbe',documentId)
            this.setBewerb(bewerb)
            this.isLoading = false
        },
        replaceSportJahrRoute(){
            if ( this.sportJahr !== this.$route.query.sportJahr ) {
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.sportJahr = this.sportJahr;
                this.$router.replace({path: p, query: q});
            }
        },
        resetCurrentData(){
            this.currentBewerb = null;
            this.currentRunde = null;
            this.currentTeam = null;
            this.currentSpiel = null;
        },
        setBewerb(bewerb){
            if ( bewerb?.deletedBy ) { this.bewerb = null; return}
            this.bewerb = bewerb ? new Bewerb(bewerb, this.landesverband.id, this.liga.id) : null
        },
    // meisterschaft und Bewerb action
        meisterschaftAction(action){
            console.log ("meisterschaftAction", action);
            if ( action === 'edit' || action === 'delete' ) {
                this.$emit('meisterschaftAction', action);
            } else if ( action === 'editBewerb') {
                this.currentBewerb = !this.bewerb ? null : JSON.parse(JSON.stringify(this.bewerb));
                this.openRoute(action)
            } else if ( action === 'deleteBewerb') {
                this.bewerb = null
            } else {
                console.log ("Unbehandelte meisterschaftsAction", );
            }
        },
        rundenAction(params){
            if ( params.action === 'editMeisterschaftTeam' || params.action === 'editRundeTabResult') {
                this.currentRunde = params.runde;
                this.currentTeam = !params.team ? null : JSON.parse(JSON.stringify(params.team));
                this.currentSpiel = params.spiel;
                this.openRoute(params.action)
            } else if (params.action === 'editRundeSettings') {
                this.currentRunde = params.runde;
                this.openRoute(params.action)
            } else if (params.action === 'editSpielKoResult') {
                this.currentSpiel = params.spiel;
                this.openRoute(params.action)
            } else {
                console.error ("Unbehandelte rundenAction", );
            }
        },
        editSpielResult(spiel){
            this.currentSpiel = spiel;
            this.openRoute('editSpielKoResult')
        },
            openRoute(action){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = action;
                this.$router.push({path: p, query: q});
            },
        confirmClearSpiel(params){
            this.currentSpiel = params.spiel;
            this.currentRunde = this.bewerb.runden[params.rundenId];
            this.confirmClearOpen = true;
        },
        closeSpielClearConfirm(){
            this.confirmClearOpen = false;
            this.currentSpiel = null;
            this.currentRunde = null;
        },
    },
    watch: {
        ligaIdParam(to){
            if ( to ) { this.loadSelectedBewerb(this.$route.query.bewerbTyp) }
        },
        sportJahr(to){
            if ( to ) {
                this.replaceSportJahrRoute()
                this.loadSelectedBewerb(this.$route.query.bewerbTyp)
            }
        },
        tabRundeAdded(to, from){
            if ( from.bewerbId !== null && to.bewerbId === from.bewerbId ) {
                if ( to.tabs !== from.tabs ) {
                    this.loadSelectedBewerb(this.$route.query.bewerbTyp)
                }
            }
        }
    }
}
</script>

<style scoped>

</style>